<template>
  <div>
    <!-- Search, Map, Filtering pieces -->
    <section
      id="mapInterface"
      class="
        page-layout__section
        u-display
        xu-display--medium
        page-layout__section--w-bg
        u-bg-white
        page-layout__section--touch-next
      ">

      <div class="page-layout__section-inner">

   
        <div class="row">
          <SearchBox />
          <sidebarMobile class="d-lg-none" /> 
        </div>
                        

        <div class="row" id="interfaceHolder">
          <div class="col-lg-10" id="mapHolder">
            <Map />
          </div>
          <div class="col-md-2" id="sideBarBox">
            <Sidebar class="d-none d-lg-block" />
          </div>
        </div>
      </div>

          <!-- Internet Wait Time Legend. 
              Show only if we're in the wait time window
              And only if IWT is successfully loaded -->
              <!-- Are we in the window of time to display Internet Wait Time?  Boolean   || isIWTLoaded -> Is IWT data loaded? Boolean-->
          <div v-if="this.rootStore.iwtLoadWindow === true && this.rootStore.isIWTLoaded === true" class="page-layout__section-inner" id="IWTlegend" style="margin-top:5px;">
            <p class='caption'><span>Driver License wait times:</span>
              <img loading="lazy" alt="Icon representing an office with under an hour wait time" src="assets/pin_dl_open.svg" /> Under an hour  
              <img loading="lazy" alt="Icon representing an office with a one to two hour wait time" src="assets/pin_dl_open_yellow_dot_triangle.svg" /> 1 - 2 hours  
              <img loading="lazy" alt="Icon representing an office with a wait time greater than two hours" src="assets/pin_dl_open_red_dot_stripe.svg" /> 2+ hours
            </p>
          </div>
    </section>

    <!-- result cards -->
    <section
      class="
        page-layout__section
        u-display
        xu-display--medium
        page-layout__section--w-bg
        u-bg-light-gray
        page-layout__section--touch-next
      "
    >
      <div
        class="page-layout__section-inner container-fluid no-gutters"
        style="max-width: 85rem;margin:0 auto"
      >
        <div class="row" id="selectedNearby">
          <div class="col-sm-12 col-lg-9" v-if="this.rootStore.primaryCard.length !== 0">
            <h2
              class="heading heading--beta section-title section-title--alt"
              v-if="this.rootStore.primaryCard.length !== 0"
            >
              <span class="section-title__text">Selected Location</span>
            </h2>
          </div>

          <div
            class="col-lg-3 d-none d-lg-block"
            v-if="this.rootStore.officesNearby.length !== 0 && this.rootStore.primaryCard.length !== 0"
            style="text-align: right"
          >
            <em v-if="this.rootStore.officesNearby.length !== 0">Nearby Offices</em>
          </div>
        </div>

        <div class="col-sm-12" id="locationCards">
          <SecondaryCards />
        </div>
      </div>
    </section>

    <!--  stats -->
    <section
      id="officeStatsCallout"
      class="
        page-layout__section
        u-display u-display--medium
        page-layout__section--w-bg
        u-bg-accent-light-blue
      "
    >
      <div class="page-layout__section-inner container-fluid">
        <h3
          class="
            heading heading--beta
            section-title section-title--alt
            u-color-white
          "
        >
          <span class="section-title__text">Statewide NCDMV Office Stats</span>
        </h3>
        <div class="row">
          <div class="col-sm-12">
            <Callouts />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>








<script>
import SearchBox from "./SearchBox.vue";
import sidebarMobile from "./SidebarMobile.vue";
import Sidebar from "./Sidebar.vue";
import Map from "./MapComponent.vue";
import Callouts from "./Callouts.vue";
import SecondaryCards from "./SecondaryCards.vue";
import { useRootStore } from "../store";

export default {
  name: "PublicOfficeLocations",
  components: {
    Sidebar,
    sidebarMobile,
    SearchBox,
    Callouts,
    Map,
    SecondaryCards,
  },
  data() {
    return {
      rootStore: useRootStore()
    }
  },
  computed: {
  },
};
</script>